export const SvgRightArrow: string = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2033%2030"%3E%3Cpath%20d%3D"M18.09%2029.83%2033%2015%2018.11.16h-3.26l13.67%2013.55H0v2.52h28.52l-13.68%2013.6Z"%2F%3E%3C%2Fsvg%3E';
export default SvgRightArrow;
